import { useMemo } from "react";
import { useTheme } from "@fluentui/react/lib/Theme";
import { IStyleSet, mergeStyleSets } from "@fluentui/react/lib/Styling";

const classNames = {
  root: `TileFooter`
};

export function useTileFooterStyles(styleSet: IStyleSet) {
  const { semanticColors } = useTheme();
  return useMemo(
    () => mergeStyleSets(
      {
        root: [
          classNames.root,
          {
            backgroundColor: semanticColors.buttonBackgroundDisabled,
            overflow: `hidden`,
            width: `100%`
          }
        ]
      },
      styleSet
    ),
    [semanticColors, styleSet]
  );
}
